<template>
  <el-dialog :visible.sync="visible" :title="'家长微信公众号绑定情况'" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.className" placeholder="班级名" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.bindStatus" placeholder="绑定状态" clearable>
          <el-option  label="已绑定" :value="weChatBindStatus.yes"></el-option>
          <el-option  label="未绑定" :value="weChatBindStatus.no"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="exportStudentBindList()">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataListLoading" :data="this.dataList" border  @selection-change="dataListSelectionChangeHandle"
              style="width: 100%;">
      <el-table-column prop="studentName" label="姓名" header-align="center" align="center"></el-table-column>
      <el-table-column prop="className" label="班级名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="isBindWeChat" label="绑定状态" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isBindWeChat === weChatBindStatus.yes">已绑定</el-tag>
          <el-tag v-else-if="scope.row.isBindWeChat === weChatBindStatus.no" type="danger">未绑定</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="绑定账号" header-align="center" align="center">
        <template slot-scope="scope">
          <span :key="g" v-for="g in scope.row.parentPhone">{{g}};</span>
        </template>
      </el-table-column>班主任微信公众号绑定情况查看
    </el-table>
    <el-pagination
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import mixinViewModule from '@/mixins/view-module'
import { weChatBindStatus } from '@/constant'
import qs from 'qs'
import Cookies from 'js-cookie'
export default {
  name: 'teacher-class-config',
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/student/student/getStudentWeChatBandStatus',
        getDataListIsPage: true,
        exportURL: '/classmanage/classmanage/export',
        deleteURL: '/classmanage/classmanage',
        deleteIsBatch: true
      },
      weChatBindStatus,
      visible: false,
      teacherCourseConfigVisible: false,
      dataForm: {
        bindStatus: '',
        className: ''
      },
      submitForm: {
        id: '',
        teacherId: '',
        teacherName: '',
        classId: '',
        className: '',
        classList: []
      },
      dataList: []
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.getDataList()
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.submitForm.classList = this.dataListSelections
      this.$http.post('/teacher/teacherClassConfig/teacherClassConfig', this.submitForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    }, 1000, { leading: true, trailing: false }),
    // 导出学生微信绑定情况
    exportStudentBindList () {
      const params = qs.stringify({
        token: Cookies.get('token'),
        className: this.dataForm.className,
        bindStatus: this.dataForm.bindStatus
      })
      window.open(`${window.SITE_CONFIG.apiURL}/student/student/exportStudentBindList?${params}`)
    }
  },
  components: {
  }

}
</script>
